import React, { useState, useEffect } from 'react';
import Select from 'react-select';

function CategoryUpload() {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const backendBaseUrl = apiLocalUrl;

    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`)
            .then((res) => res.json())
            .then((data) => setCategories(data));
    }, []);

    const handleCategoryChange = (selected) => {
        setSelectedCategory(selected);
        setSelectedImage(null);
        setUploadStatus('');
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setUploadStatus('');
        }
    };

    const handleImageUpload = async () => {
        if (!selectedCategory || !selectedImage) {
            alert('Please select a category and image before uploading.');
            return;
        }

        const format = selectedImage.name.split('.').pop().toLowerCase();
        const formData = new FormData();
        formData.append('image', selectedImage);

        try {
            const response = await fetch(
                `${backendBaseUrl}/upload-category-image/${selectedCategory.value}.${format}`,
                {
                    method: 'POST',
                    body: formData,
                }
            );

            if (response.ok) {
                setUploadStatus('success');
                const data = await response.json();
                alert(`Category image uploaded successfully with the name: ${data}`);
            } else {
                setUploadStatus('error');
                alert('Image upload failed');
            }
        } catch (error) {
            console.error(error);
            setUploadStatus('error');
            alert('Image upload Success!');
        }
    };

    return (
        <div className="max-w-2xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-2xl">
            <h1 className="text-3xl font-bold text-center text-indigo-600 mb-6">Upload Category Image</h1>

            <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Category</label>
                <Select
                    onChange={handleCategoryChange}
                    value={selectedCategory}
                    isClearable
                    isSearchable
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={categories.map((cat) => ({
                        value: cat.Id,
                        label: cat.Name,
                    }))}
                />
            </div>

            {selectedCategory && (
                <div className="mb-6">
                    <label htmlFor="categoryImageUpload" className="block text-sm font-medium text-gray-700 mb-2">
                        Choose Category Image
                    </label>
                    <input
                        id="categoryImageUpload"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none hover:border-indigo-500 transition duration-150"
                    />
                </div>
            )}

            {selectedImage && (
                <>
                    <div className="mt-6">
                        <h2 className="text-lg font-semibold mb-2 text-gray-800">Image Preview:</h2>
                        <img
                            src={URL.createObjectURL(selectedImage)}
                            alt="Category preview"
                            className="w-full max-h-80 object-contain rounded-lg shadow-md border border-gray-300"
                        />
                    </div>

                    <button
                        onClick={handleImageUpload}
                        className="mt-4 bg-indigo-600 hover:bg-indigo-700 bg-[red] text-[white] text-white font-semibold py-2 px-4 rounded shadow"
                    >
                        Upload Image
                    </button>

                    {/* {uploadStatus === 'success' && (
                        <p className="mt-2 text-sm text-green-600">Image uploaded successfully!</p>
                    )}
                    {uploadStatus === 'error' && (
                        <p className="mt-2 text-sm text-red-600">Error uploading image</p>
                    )} */}
                </>
            )}
        </div>
    );
}

export default CategoryUpload;
